import React, { useEffect, useState } from 'react';
import { TouchableOpacity, View } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';

import { ThemedText } from '@/components/ThemedText';
import { ThemedView } from '@/components/ThemedView';
import { useAuth } from '@components/auth/useAuth';

export default function HelloWorldScreen() {
  const { signOut, user } = useAuth();
  const [secondsRemaining, setSecondsRemaining] = useState(10);
  const [isTimerRunning, setIsTimerRunning] = useState(false);

  useEffect(() => {
    if (!isTimerRunning) return;

    if (secondsRemaining <= 0) {
      signOut();
      return;
    }

    const timer = setInterval(() => {
      setSecondsRemaining((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [secondsRemaining, signOut, isTimerRunning]);

  return (
    <ThemedView className="flex-1 justify-center flex-row">
      <SafeAreaView className="flex-1 px-4 items-center justify-center max-w-[800px]">
        <ThemedView className="items-center justify-center flex-1 px-4 gap-6">
          <View className="items-center gap-2">
            <ThemedText type="title" className="text-center font-bold">
              Hello World!
            </ThemedText>
            <ThemedText type="subtitle" themeColor="textSecondary" className="text-center text-xl">
              Welcome, {user?.displayName}!
            </ThemedText>
          </View>

          {!isTimerRunning ? (
            <TouchableOpacity
              className="bg-blue-500 active:bg-blue-600 px-8 py-3.5 rounded-xl shadow-lg shadow-blue-500/20 w-full max-w-[320px]"
              onPress={() => setIsTimerRunning(true)}
            >
              <ThemedText className="text-white font-bold text-base text-center">Start Countdown</ThemedText>
            </TouchableOpacity>
          ) : (
            <ThemedView type="backgroundElement" className="px-6 py-4 rounded-2xl items-center w-full max-w-[320px] shadow-sm">
              <ThemedText themeColor="textSecondary" className="text-sm font-semibold text-center mb-1">
                Simulation Active
              </ThemedText>
              <ThemedText className="text-blue-500 dark:text-blue-400 font-bold text-lg text-center">
                Auto-logout in {secondsRemaining}s
              </ThemedText>
            </ThemedView>
          )}

          <TouchableOpacity
            className="bg-red-500 active:bg-red-600 px-8 py-3.5 rounded-xl shadow-lg shadow-red-500/20"
            onPress={signOut}
          >
            <ThemedText className="text-white font-bold text-base">Sign Out Now</ThemedText>
          </TouchableOpacity>
        </ThemedView>
      </SafeAreaView>
    </ThemedView>
  );
}
